import React, { FC } from 'react';
import { range } from 'ramda';
import { TableRow } from '@dxb-web-ui-framework/design-system';
import { SkeletonTableCell } from '../SkeletonTableCell/SkeletonTableCell';
import { ColumnDef } from '../../types';

export interface SkeletonTableGridRowProps {
  hasSkeleton: boolean;
  columnDefs: ColumnDef[];
  skeletonsToDisplay?: number;
}

const SkeletonTableGridRow: FC<SkeletonTableGridRowProps> = ({ hasSkeleton, columnDefs, skeletonsToDisplay = 3 }) => (
  <>
    {range(0, skeletonsToDisplay).map(item => (
      <TableRow key={`skeleton-table-row-${item}`}>
        {columnDefs.map(columnDef => (
          <SkeletonTableCell
            key={`skeleton-table-cell-${columnDef.id}`}
            tableCellProps={columnDef.cellProps}
            hasSkeleton={hasSkeleton}
          />
        ))}
      </TableRow>
    ))}
  </>
);

export { SkeletonTableGridRow };
